var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.options.verticalText)?_c('span',{staticClass:"vertical_text absolute top-0 left-0 transform -rotate-180 font-bold whitespace-nowrap",class:['text-' + _vm.options.color],domProps:{"innerHTML":_vm._s(_vm.options.verticalText)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }